import { Injectable, inject } from '@angular/core';
import { AuthCredentials } from '../interfaces/auth-credentials.interface';
import { Session } from '../interfaces/session.interface';
import { UserProfile } from '../interfaces/user-profile.interface';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);

  public login(credentials: AuthCredentials): Observable<Session> {
    return this.http.post<Session>(`${environment.api}/services/user/login`, {
      username: credentials.email,
      password: credentials.password,
    });
  }

  public initForgotPassword(
    email: string,
    verification: 'email' | 'sms'
  ): Observable<{ verificationSentTo: string } | null> {
    return this.http.post<{ verificationSentTo: string } | null>(
      `${environment.api}/services/user/reset-password/init`,
      {
        email,
        verification,
      }
    );
  }

  public verifyCode(email: string, code: string): Observable<{ resetPasswordToken: string }> {
    return this.http.post<{ resetPasswordToken: string }>(
      `${environment.api}/services/user/reset-password/verify-code`,
      { email, code }
    );
  }

  public resetPassword(password: string, resetPasswordToken: string): Observable<void> {
    return this.http.post<void>(`${environment.api}/services/user/reset-password`, { password, resetPasswordToken });
  }

  public getProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${environment.api}/services/cerebro/user/profile`);
  }

  public changeProfile(profile: Partial<UserProfile>): Observable<UserProfile> {
    return this.http.put<UserProfile>(`${environment.api}/services/cerebro/user/profile`, profile);
  }
}
